export const luncPackagesTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Package name", colWidth: "200px", key: "name" },
  { titleName: "Package rate", colWidth: "150px", key: "rate" },
];
